/** The words of "Will be issued as", from the two reads the filing's page already uses. See
 * `IssueSnapshot.tsx` for what the line is for. */

import { useFilingChecks } from "../../api/filingChecks";
import type { Scope2Method } from "../../api/queries";
import { useReport } from "../../api/queries";
import { amount } from "../reportsFormat";
import { verdictWord } from "./words";

/** The parts of the line, in the order a reader weighs them. `undefined` until both reads answer: a
 * snapshot with a part missing would state less than will be frozen. Nothing is computed: the verdict
 * and the blocking count are the server's, and so is the total (a string, never a sum). */
export function useIssueSnapshot(obligationId: string, method: Scope2Method): string[] | undefined {
  const checks = useFilingChecks(obligationId, method);
  const report = useReport(obligationId, method);
  if (!checks.data || !report.data) return undefined;
  const blocking = checks.data.counts.blocking ?? 0;
  const verdict = checks.data.summary.verdict;
  const approved = verdict === "approved" || verdict === "issued";
  return [
    verdictWord(verdict).word,
    blocking === 0 ? "no blocking checks" : `${String(blocking)} blocking check${blocking === 1 ? "" : "s"}`,
    approved ? "approved" : "not approved",
    `${amount(report.data.stated_total_tonnes, "tCO2e")} tCO₂e ${method}-based`,
  ];
}
